import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";

ReactDOM.render(
  (
    <Router>
      <App />
      <CookieConsent>
        This site uses cookies to analyse traffic, remember your preferences, and optimise your experience.<br />
        To learn more about how we use cookies, please read our <Link to='/privacy'>Privacy Policy</Link>
      </CookieConsent>
    </Router>
  ), document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

(function() {
  // console.log('foo');
  // console.log(sessionStorage.length);
  //source: http://blog.guya.net/2015/06/12/sharing-sessionstorage-between-tabs-for-secure-multi-tab-authentication/
	if (!sessionStorage.length) {
		// Ask other tabs for session storage
		localStorage.setItem('btg.ssSync', Date.now());
	};

  window.addEventListener('storage', function(event) {
    // console.log('storage event', event);

		if (event.key === 'btg.ssSync') {
			// Some tab asked for the sessionStorage -> send it
			localStorage.setItem('btg.ss', JSON.stringify(sessionStorage));
			localStorage.removeItem('btg.ss');
		} else if (event.key === 'btg.ss' && !sessionStorage.length) {
		  // sessionStorage is empty -> fill it
			var data = JSON.parse(event.newValue);
			for (var key in data) {
			  sessionStorage.setItem(key, data[key]);
		  }
	  }
  });

	window.onbeforeunload = function() {
		//sessionStorage.clear();
	};
})();
